import { INITIALIZE_SOCKET } from "../constants";

const initialState = {
    initializeSocket: false
};

const socketReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case INITIALIZE_SOCKET:
            return {
                ...state,
                initializeSocket: action.payload,
            };
        default:
            return state;
    }
};

export default socketReducer;
